import "../../_generated_templates.js";
window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.CompletionPage = class CompletionPage extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
  }

  initialize() {
    return this.listenTo(this.model, "change", this.render);
  }

  render() {
    this.$el.html(this.template(this.model.attributes));
    return this;
  }

  triggerCompletionPageClicked() {
    return this.$el.trigger(AssessmentBuilder.Events.CompletionPage.clicked, [this.model]);
  }

  triggerRemoveCompletionPageClicked() {
    return this.$el.trigger(AssessmentBuilder.Events.CompletionPage.removeClicked, [this.model]);
  }
};
AssessmentBuilder.Views.CompletionPage.prototype.tagName = "completion-page-element";
AssessmentBuilder.Views.CompletionPage.prototype.template = _.template(
  AssessmentBuilder.Templates.CompletionPage.completion_page,
);

AssessmentBuilder.Views.CompletionPage.prototype.events = {
  click: "triggerCompletionPageClicked",
  "click remove-completion-page-button": "triggerRemoveCompletionPageClicked",
};
